import { useContext, useState } from 'react';
import { Switch, Route, Redirect, HashRouter } from 'react-router-dom';
import { getCookie, handleLogOut } from 'mmbclient/Common/CommonFunctions';
import Login from 'mmbclient/Login/Login';
import { ACCOUNT_STATEMENT, BOOKING_DETAIL1, BOOKING_DETAIL2, DASHBOARD1, GLOBAL_CONTEXT, INVOICE_DETAIL, LOGIN_COOKIE_NAME, PAGE_COOKIE_NAME, PICKUP_REQUEST, PICKUP_STATUS, TRACKING } from 'mmbclient/Common/CommonVariable';
import { USER_COOKIE_THROTTLE_TIME, USER_COOKIE_NAME, WEBSITE_SESSION_STORAGE } from 'mmbclient/Common/CommonVariable';
import { setUserCookie } from 'mmbclient/Common/CommonFunctions';
import PageNotFound from 'mmbclient/Components/PageNotFound';
import { SidebarMenu } from './SidebarMenu';
import './SidebarMenu.css';
import 'mmbclient/Components/AuthRouting.css'
import { HomePage } from 'mmbclient/Home/HomePage';
// import { Link } from '@material-ui/core';
import { Dashboard } from 'mmbclient/Dashboard/Dashboard';
import { ConsignmentDetail } from 'mmbclient/Reports/ConsignmentDetail';
import { InvoiceDetail } from 'mmbclient/Reports/InvoiceDetail';
import { AccountStatement } from 'mmbclient/Reports/AccountStatement';
import { CreditPickUpRequest } from 'mmbclient/CreditPickUpRequest/CreditPickUpRequest';
import { Tracking } from 'mmbclient/Tracking/Tracking';
import { CreditPickUpStatus } from 'mmbclient/CreditPickUpRequest/CreditPickUpStatus';
import { ConsignmentDetail2 } from 'mmbclient/Reports/ConsignmentDetail2';


const AuthRouting = () => {

    const store = useContext(GLOBAL_CONTEXT);

    const pages = getCookie(PAGE_COOKIE_NAME).split(',');

    function handleLog() {
        handleLogOut(store);
    }

    if (store.login === 'out') {

        const u = getCookie(LOGIN_COOKIE_NAME);

        // sets cookie for logged in user
        if (u !== '') {
            setUserCookie(USER_COOKIE_NAME, u, USER_COOKIE_THROTTLE_TIME);
        }

        // sets page routing for non-logged in user & login page for login user
        let page = "";
        const hashUrl = window.location.hash;
        if (hashUrl && hashUrl.split('?').length > 1) { // if url is url.com:port/mmbclient/#/pickup-request?website=website-name
            const hashUrl = window.location.hash;       // url.com:port/mmbclient/#/pickup-request?website=website-name
            const tempArr = hashUrl.split('?');
            page = tempArr[0].substring(2);     // page-name .....   url -> #/
            const parameter = tempArr[1].split('&');
            const param1 = parameter[0];        // first param
            // const param2 = parameter[1];        // second param & so on
            const paramArr1 = param1.split('=');
            const paramName1 = paramArr1[0];
            const paramValue1 = paramArr1[1];

            if (page === "cash-pickup-request" && paramName1 === "website" && paramValue1 !== undefined && paramValue1 !== "") {
                sessionStorage.setItem(WEBSITE_SESSION_STORAGE, paramValue1);        // set session storage for non-logged in user
            } else if (page === "login" && paramName1 === "website" && paramValue1 !== undefined && paramValue1 !== "") {
                setUserCookie(USER_COOKIE_NAME, paramValue1, USER_COOKIE_THROTTLE_TIME)       // sets cookie for logged in user
            } else {
                page = "page-not-found";
            }
        } else {
            page = hashUrl;     //   url -> domain-name.com:port/mmbclient
            if (page === "") {
                page = "login";
            } else {
                page = hashUrl;     //   #/pickup-request     (url -> domain-name.com:port/mmbclient/#/pickup-request)
                page = page.substring(2);       //  pickup-request
                if (page === 'login') {
                    page = 'login';
                } else if (page === 'cash-pickup-request') {
                    if (sessionStorage.getItem(WEBSITE_SESSION_STORAGE) === null) {
                        page = 'page-not-found';
                    }
                } else {
                    page = 'page-not-found';
                }
            }
        }

        // window.history.replaceState(null, '', '/mmbclient/' + window.location.hash);
        page = "#/" + page;
        window.history.replaceState(null, '', '/mmbclient/' + page);

        // fall back url is /login i.e. login page
        // first enter always falls back to default page i.e. login page when url after # is changed...other wise refresh occurs & code works

        return (
            <>
                <HashRouter>
                    <Switch>
                        <Route exact path={`/login`} component={Login} />
                        {/* <Route exact path='/cash-pickup-request' component={CashPickUpRequest} /> */}
                        <Route exact path='/page-not-found' component={PageNotFound} />
                        <Route component={() => <Redirect to={`/login`} />} />
                    </Switch>
                </HashRouter>
            </>
        );

    } else if (store.login === 'in') {

        window.history.replaceState(null, '', '/mmbclient/' + window.location.hash);

        // return (
        //     <>
        //         <SidebarMenu />
        //     </>
        // )
        return (
            <>
                <HashRouter>
                    <div class="wrapper">
                        <SidebarMenu />
                        {/* <div class="sidebar-footer">
                                <Link class="sidebar-link" onClick={handleLog} style={{ cursor: 'pointer' }}>
                                    <i class="bi bi-box-arrow-right"></i>
                                    <span>Logout</span>
                                </Link>
                            </div> */}
                        <div class="main">
                            {/* <div class="container-fluid">                                 */}
                            {/* Navigation Header */}
                            <nav className="navbar navbar-light bg-light" style={{ backgroundColor: '#3579c3' }}>
                                <div className="container">
                                    <span className="navbar-brand mx-auto">
                                        {global.ClientName1 === undefined ? global.ClientName2 : global.ClientName1}
                                    </span>
                                </div>
                            </nav>
                            <Switch>
                                {/* {!pages.includes(DASHBOARD1) &&
                            <Route exact path='/dashboard' component={Dashboard} />} */}
                                {/* {!pages.includes(DOMESTIC_BOOKING) &&
                            <Route exact path='/booking' component={DataEntry} />} */}
                                {/* <Route exact path='/online-booking-search' component={OnlineBookingSearch} /> */}
                                <Route exact path='/homepage' component={HomePage} />
                                {/* <Route exact path='/consignment-detail' component={ConsignmentDetail} /> */}
                                {!pages.includes(DASHBOARD1) &&
                                    <Route exact path='/dashboard' component={Dashboard} />}
                                {!pages.includes(BOOKING_DETAIL1) &&
                                    <Route exact path='/consignment-detail' component={ConsignmentDetail} />}
                                {!pages.includes(BOOKING_DETAIL2) &&
                                    <Route exact path='/consignment-detail' component={ConsignmentDetail2} />}
                                {!pages.includes(INVOICE_DETAIL) &&
                                    <Route exact path='/invoice-detail' component={InvoiceDetail} />}
                                {!pages.includes(ACCOUNT_STATEMENT) &&
                                    <Route exact path='/account-statement' component={AccountStatement} />}
                                {!pages.includes(TRACKING) &&
                                    <Route exact path='/tracking' component={Tracking} />}
                                {!pages.includes(PICKUP_REQUEST) &&
                                    <Route exact path='/credit-pickup-request' component={CreditPickUpRequest} />}
                                {!pages.includes(PICKUP_STATUS) &&
                                    <Route exact path='/credit-pickup-status' component={CreditPickUpStatus} />}
                                {/* Default Page */}
                                <Route component={() => <Redirect to="/homepage" />} />
                            </Switch>
                            {/* </div> */}
                        </div>
                    </div>
                    {/* <SidebarMenu /> */}
                    {/* <Navbar /> */}
                </HashRouter >
            </>
        );

    } else {
        return null;
    }
}

export default AuthRouting
